
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { cn } from '@/lib/utils';

const SkipToContent: React.FC = () => {
  const { currentLanguage } = useLanguage();
  
  const skipText = currentLanguage === 'de' ? 'Zum Hauptinhalt springen' :
                  currentLanguage === 'fr' ? 'Passer au contenu principal' :
                  currentLanguage === 'it' ? 'Passa al contenuto principale' : 
                  'Skip to main content';
  
  return (
    <a 
      href="#main-content" 
      className={cn(
        "sr-only focus:not-sr-only focus:fixed focus:top-6 focus:left-6 focus:z-50",
        "focus:px-6 focus:py-3 focus:bg-purple-600 focus:text-white focus:outline-none",
        "focus:ring-4 focus:ring-purple-300 focus:ring-offset-2", 
        "focus:shadow-lg focus:font-medium focus:rounded-md",
        "focus:animate-in focus:fade-in focus:duration-200",
        "transition-all ease-in-out"
      )}
      data-testid="skip-link"
      aria-label={skipText}
      onClick={(e) => {
        // Ensure the main content receives focus when skip link is clicked
        const mainContent = document.getElementById('main-content');
        if (mainContent) {
          e.preventDefault();
          mainContent.setAttribute('tabindex', '-1');
          mainContent.focus();
          // Remove the tabindex after focus to avoid strange behavior when clicking elsewhere
          setTimeout(() => {
            mainContent.removeAttribute('tabindex');
          }, 1000);
        }
      }}
    >
      {skipText}
    </a>
  );
};

export default SkipToContent;
